import { useEffect } from 'react';

import usePageSlug from './usePageSlug';

const useSendPageSlugToDD = () => {
  const { slug } = usePageSlug();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const datadogRum = (window as any).DD_RUM;
    if (!datadogRum?.isInitialized || !slug) return;

    const [landingName] = slug.split('/');

    datadogRum.setGlobalContextProperty('landing_name', landingName);
  }, [slug]);
};

export default useSendPageSlugToDD;
